module.exports = __webpack_public_path__ + "img/icon_judgment.2cf528a9.svg";